export default __webpack_public_path__ + "static/media/I0000.3793a712.png";